"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packRawClusterAgentData = exports.packRawClusterAgentDataToHash = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const codec_1 = require("@ckb-lumos/codec");
function packRawClusterAgentDataToHash(packable) {
    return lumos_1.utils.computeScriptHash(packable);
}
exports.packRawClusterAgentDataToHash = packRawClusterAgentDataToHash;
function packRawClusterAgentData(packable) {
    const hash = packRawClusterAgentDataToHash(packable);
    return codec_1.bytes.bytify(hash);
}
exports.packRawClusterAgentData = packRawClusterAgentData;
//# sourceMappingURL=clusterAgent.js.map